export enum AccountOwnerType {
  // 10/30/2025: Adding comment here to remind us that INDIVIDUAL_BY_NAME includes joint ownership (shown in the related description in the account-owner-content.ts file)
  INDIVIDUAL_BY_NAME = "individual-by-name",
  BUSINESS = "business",
  // 5/19/25 temp removing the I'm not sure flow
  // NOT_SURE = 'not-sure',
  // NOT_SURE_DISPLAY = "I'm not sure how this is titled",
  TRUST = "trust",
  CHARITY = "charity",
}
